

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authSlice from './common/auth-slice';
import loaderSlice from './common/loader-slice';
import alertSlice from './common/alert-slice';

const staticReducers = {
    auth: authSlice,
    loader: loaderSlice,
    alert: alertSlice,
};
let asyncReducers = {};

const createReducer = () => combineReducers({
    ...staticReducers,
    ...asyncReducers,
});

const store = configureStore({
    reducer: createReducer(),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    devTools: process.env.NODE_ENV !== 'production',
});

store.asyncReducers = asyncReducers;

export const injectReducer = (key, asyncReducer) => {
    if (!asyncReducers[key]) {
        store.asyncReducers[key] = asyncReducer;
        store.replaceReducer(createReducer());
    }
};

export default store;

